export const cart = state => {
  return state.cart;
};
export const stockCart = state => {
  return state.stock_cart;
};
export const order = state => {
  return state.order;
};
export const categories = state => {
  return state.categories;
};
export const figures = state => {
  return state.figures;
};
export const designs = state => {
  return state.designs;
};
export const colors = state => {
  return state.colors;
};
export const parts = state => {
  return state.parts;
};
export const textParts = state => {
  return state.text_parts;
};
// export const active_tab = state => {
//   return state.active_tab;
// };
export const active_tab = state => {
  return state.active_tab;
};
export const designPrice = state => (cart = null) => {
  if (cart === null) cart = state.cart;
	let price = 0;
	// タイプの価格
	if (cart.figure) {
		price += cart.figure.price;
	}
	// デザインの価格
	if (cart.design) {
		price += cart.design.add_price;
	}
	// 画像パーツの価格
	for (let i = 0; i < cart.parts.length; i++) {
		if (!cart.parts[i].pictures) continue;
		for (let j = 0; j < cart.parts[i].pictures.length; j++) {
			price += cart.parts[i].pictures[j].add_price;
		}
	}
	return price;
};
export const basePrice = (state, getters) => (cart = null) => {
  if (cart === null) cart = state.cart;
  let price = getters.designPrice(cart);
  // 色の価格
  for (let i = 0; i < cart.parts.length; i++) {
    if (!cart.parts[i].designs_part.color) continue;
    price += cart.parts[i].designs_part.color.price;
  }
  // 文字の価格
  for (let i = 0; i < cart.letters.length; i++) {
    if (!cart.letters[i].decoration) continue;
    price += cart.letters[i].decoration.price;
    if (cart.letters[i].decoration.color) {
      price += cart.letters[i].decoration.color.price;
    }
  }
  return price;
};
export const packTotalPrice = (state, getters) => (index, cart = null) => {
  if (cart === null) cart = state.cart;
	let base_price = getters.basePrice(cart);
	let pack_price = ((Number(base_price) + Number(cart.packs[index].pack_price)))
    * Number(cart.packs[index].value);
	return pack_price;
};
export const totalPrice = (state, getters) => (cart = null) => {
  if (cart === null) cart = state.cart;
  if (! cart.packs[0].value){
    return getters.basePrice(cart);
  }
  let total_price = 0;
  if (cart.packs.length){
    for (let i = 0; i < cart.packs.length; i++) {
      total_price += getters.packTotalPrice(i, cart);
    }
  }
  return total_price;
};

export const cartStockTotalPrice = (state, getters) => {
  let price = 0;
  state.stock_cart.forEach(cart => {
    const basePrice =  getters.cartStockBasePrice(cart);
    cart.packs.forEach(pack => {
      const cartPrice = basePrice + getters.cartStockPackAddPrice(pack);
      price += cartPrice * pack.value;
    })
  });
  return price;
};

export const cartStockBasePrice = (state, getters) => (cart) => {
  let price = getters.cartStockDesignPrice(cart);
  // 色の価格
  for (let i = 0; i < cart.parts.length; i++) {
    if (!cart.parts[i].designs_part.color) continue;
    price += cart.parts[i].designs_part.color.price;
  }
  // 文字の価格
  for (let i = 0; i < cart.letters.length; i++) {
    if (!cart.letters[i].decoration) continue;
    price += cart.letters[i].decoration.price;
    if (cart.letters[i].decoration.color) {
      price += cart.letters[i].decoration.color.price;
    }
  }
  return price;
};

export const cartStockDesignPrice = () => cart => {
  let price = 0;
  // タイプの価格
  if (cart.figure) {
    price += cart.figure.price;
  }
  // デザインの価格
  if (cart.design) {
    price += cart.design.add_price;
  }
  // 画像パーツの価格
  for (let i = 0; i < cart.parts.length; i++) {
    if (!cart.parts[i].pictures) continue;
    for (let j = 0; j < cart.parts[i].pictures.length; j++) {
      price += cart.parts[i].pictures[j].add_price;
    }
  }
  return price;
};

export const cartStockPackAddPrice = () => (pack) => {
  let pack_price = Number(pack.pack_price) * Number(pack.value);
  return pack_price;
};

export const packs = state => {
  return state.cart.packs;
};
export const check_able_order = state => {
	return (state.cart.figure && state.cart.design);
};

export const modals = state => {
  return state.modals;
};
